import {
  WSActions,
  WSEmptyState,
  WSList
} from "@wingspanhq/fe-component-library";
import { verificationService } from "../../../../shared/services/verificaiton";

type Props = {
  completeOnboardingToken: string;
  onComplete?: () => void;
};

export const Documents: React.FC<Props> = props => {
  return (
    <WSList gap="2XL">
      <WSEmptyState
        type="documents"
        title="Additional documents required for banking verification"
        description="Please follow the steps in the pop-up to provide the additional documents required to activate banking feature(s). If you closed out of the pop-up before completing, click below to try again."
        hasBorder
        orientation="horizontal"
        bgColor="white"
      />

      <WSActions
        alignment="fill"
        buttons={[
          {
            kind: "Primary",
            label: "Complete document upload",
            onClick: () => {
              verificationService.openFootprintPlaybook(
                "Banking",
                props.completeOnboardingToken,
                props.onComplete
              );
            }
          }
        ]}
      />
    </WSList>
  );
};
